<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 105" width="24" height="24">
  <g
    id="Canvas_1"
    stroke="none"
    fill="none"
    fill-opacity="1"
    stroke-opacity="1"
    stroke-dasharray="none"
  >
    <g>
      <g>
        <g>
          <rect
            x="4"
            y="4"
            width="111.8"
            height="60.599996"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="7"
          />
        </g>
        <g>
          <rect
            x="71.60001"
            y="64.599996"
            width="32.000002"
            height="36"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="7"
          />
        </g>
        <g>
          <rect
            x="60.45"
            y="20.299998"
            width="37.000003"
            height="28"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="7"
          />
        </g>
        <g id="Group_9">
          <g id="Line_5">
            <line
              x1="22.350001"
              y1="21.099996"
              x2="35.349997"
              y2="21.099996"
              stroke="black"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7"
            />
          </g>
          <g id="Line_6">
            <line
              x1="22.350001"
              y1="29.899997"
              x2="35.349997"
              y2="29.899997"
              stroke="black"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7"
            />
          </g>
          <g id="Line_7">
            <line
              x1="22.350001"
              y1="38.7"
              x2="35.349997"
              y2="38.7"
              stroke="black"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7"
            />
          </g>
          <g id="Line_8">
            <line
              x1="22.350001"
              y1="47.5"
              x2="35.349997"
              y2="47.5"
              stroke="black"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
